import { Outlet } from 'react-router-dom';

// material-ui
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';

// project imports
import Header from './Header';
import Footer from 'layout/Dashboard/Footer';
import AuthGuard from 'utils/route-guard/AuthGuard';

// ==============================|| COMPANY SELECTION LAYOUT ||============================== //

export default function CompanySelectionLayout() {
  return (
    <AuthGuard>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />

        <Box component="main" sx={{ flexGrow: 1, backgroundColor: '#f5f5f5' }}>
          <Toolbar /> {/* Spacer for fixed header */}
          <Container
            maxWidth="xl"
            sx={{
              px: { xs: 2, sm: 3 },
              py: 4,
              minHeight: 'calc(100vh - 64px - 60px)', // Header and footer space
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Outlet />
          </Container>
        </Box>

        {/* Footer with bottom padding */}
        <Box sx={{ pb: 2 }}>
          <Footer />
        </Box>
      </Box>
    </AuthGuard>
  );
}
